module.exports = __webpack_public_path__ + "img/payment_success.4a452f21.png";